module.exports = __webpack_public_path__ + "img/ตู้กรองฝุ่น.10c8e908.png";